import { render, staticRenderFns } from "./DispositivosNoSeriadosDetalles.vue?vue&type=template&id=1425b09a&"
import script from "./DispositivosNoSeriadosDetalles.vue?vue&type=script&lang=ts&"
export * from "./DispositivosNoSeriadosDetalles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1425b09a', component.options)
    } else {
      api.reload('1425b09a', component.options)
    }
    module.hot.accept("./DispositivosNoSeriadosDetalles.vue?vue&type=template&id=1425b09a&", function () {
      api.rerender('1425b09a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/RecepcionEquipos/Acciones/DispositivosNoSeriadosDetalles.vue"
export default component.exports